import { render, staticRenderFns } from "./DetailsCard_share.vue?vue&type=template&id=322739ba"
import script from "./DetailsCard_share.vue?vue&type=script&lang=js"
export * from "./DetailsCard_share.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports